module.exports = __webpack_public_path__ + "static/media/tools-icon.b930b419.svg";